/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import cx from 'classnames';

import { SortIcon } from '../icon/SortIcon';

interface TableHeaderProps<D extends object> {
    column: SortableColumn<D>;
}

export function TableHeader<D extends object>({
    column,
}: TableHeaderProps<D>): JSX.Element {
    const { isSorted, isSortedDesc, headerLabel } = column;
    const headerClasses = cx('w-full h-full font-semibold text-xs', {
        'text-black': isSorted,
    });

    return (
        <div className={headerClasses}>
            <div className="w-full h-full">
                <div className={cx({ underline: isSorted })}>
                    <span className="pr-1">{headerLabel}</span>
                    <SortIcon isSorted={isSorted} isSortedDesc={isSortedDesc} />
                </div>
            </div>
        </div>
    );
}
